import { ReactNode } from "react";
import Link from "next/link";

import { stringToURI } from "@scripts/utils";
import theme from "@config/theme";

type AcceleratorLinkProps = {
  children: ReactNode;
  projectName: string;
};

const AcceleratorLink = ({ children, projectName }: AcceleratorLinkProps) => (
  <>
    <Link
      href={`/accelerators/${stringToURI(projectName)}`}
      className="accelerator-link"
    >
      {children}
    </Link>
    <style jsx>
      {`
        :global(.accelerator-link div),
        .accelerator-link:visited,
        :global(.accelerator-link:hover .featured-card-content),
        :global(.accelerator-link:hover .featured-card-content .tags) {
          color: ${theme.colors.black};
        }

        :global(.accelerator-link:hover div),
        :global(.accelerator-link:hover .tags) {
          text-decoration: none;
          color: ${theme.colors.gray3};
        }

        :global(.accelerator-link:hover .project-cta) {
          color: ${theme.colors.ultramarine};
        }

        /* workaround to prevent having to update every SVG to make hover state a different color. Codepen reference: https://codepen.io/sosuke/pen/Pjoqqp */
        :global(.accelerator-link:hover .project-logo) {
          filter: brightness(0) saturate(100%) invert(36%) sepia(15%)
            saturate(1282%) hue-rotate(163deg) brightness(97%) contrast(87%);
        }
      `}
    </style>
  </>
);

export default AcceleratorLink;
